export function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatDateTime(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatAmount(amount, currency) {
  if (amount == null || amount === "") return "—";
  const decimals = currency === "TND" ? 3 : 2;
  const formatted = Number(amount).toFixed(decimals);
  return currency ? `${formatted} ${currency}` : formatted;
}

export function formatCurrencyTotal(code, amount) {
  const decimals = code === "TND" ? 3 : 2;
  return `${code} ${Number(amount).toFixed(decimals)}`;
}

export function truncateText(text, max = 48) {
  if (!text) return "—";
  const str = String(text);
  return str.length > max ? `${str.slice(0, max)}…` : str;
}
